export default "__VITE_ASSET__C__QL8u8__"